import { DeaFilterFunction } from '../common';
import { CsaFilterForm } from './CsaFilterForm';

export const CsaPreFilter = ({
  emptyCsaSrchResult,
  searchByFilter,
  tooltipValue,
  toggleTooltip,
  offTooltip,
  onClear,
}: {
  emptyCsaSrchResult: boolean;
  searchByFilter: DeaFilterFunction;
  tooltipValue: (tooltip: string) => boolean;
  toggleTooltip: (tooltip: string) => void;
  offTooltip: (tooltip: string) => void;
  onClear: () => void;
}) => {
  return (
    <CsaFilterForm
      emptyCsaSrchResult={emptyCsaSrchResult}
      searchByFilter={searchByFilter}
      tooltipValue={tooltipValue}
      toggleTooltip={toggleTooltip}
      offTooltip={offTooltip}
      onClear={onClear}
    />
  );
};
